import { createContext, useContext } from 'react';

/**
 * Signed-in user state provided by App.js.
 *
 *   currentUser – Firebase Auth user (null when signed out)
 *   profile     – live users/{uid} document data (null when signed out)
 *   role        – profile.role, or '' when signed out
 *   authLoading – true until the first auth/profile resolution
 */
const UserContext = createContext({
  currentUser: null,
  profile: null,
  role: '',
  authLoading: true,
});

export const useUser = () => useContext(UserContext);

export default UserContext;
